<template>
    <div class="callout" style="margin: 0;">
        <div class="row">
            <div class="col-md-4">
                <input type="text" class="form-control form-control-sm" placeholder="Expediente" v-model="filtroExpediente">
            </div>
            <div class="col-md-6">
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="companiaseleccionada"
                    :options="companias" filter optionLabel="nombre" class="selector-filtro" placeholder="Compañías">
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div v-if="slotProps.option.nombre.length <= 50">{{ slotProps.option.nombre }}<span
                                    v-if="slotProps.option.prefijo">&nbsp;({{ slotProps.option.prefijo }})</span></div>
                            <div v-else>{{ slotProps.option.nombre.slice(0, 47) }}...<span
                                    v-if="slotProps.option.prefijo">&nbsp;({{ slotProps.option.prefijo }})</span></div>

                        </div>
                    </template>
                </MultiSelect>
                <MultiSelect optionValue="id" scrollHeight="400px" showClear v-model="usuarioseleccionado"
                    :options="usuarios" filter optionLabel="nombre" class="selector-filtro ml-2" placeholder="Usuarios">
                </MultiSelect>
            </div>
            <div class="col-md-2 d-flex justify-content-end">
                <button class="btn btn-primary btn-sm" @click="obtenerExpedientes(mievento)">Buscar</button>
                <Button icon="fas fa-file-excel" class="btn btn-secondary btn-sm ml-2" label="Exportar"
                    @click="montarcsv(mievento)" />
            </div>
        </div>
    </div>
    <div class="callout" style="margin-top:15px;padding:0px;">
        <tabla-datos :asignaciones="true" :botones="true" :columnas="columnas" :datos="expedientes" :filtros="false"
            :servicios="true" v-if="mostrar" :total="total" :paginator="false" @quieroDatos="obtenerExpedientes($event); mievento = $event;">
        </tabla-datos>
    </div>
</template>   
<script>
import MultiSelect from 'primevue/multiselect';
import { PwgsApi } from '../../../services/PwgsApi';
import TablaDatos from '../../TablaDatos.vue';
import jsonToCsvExport from "json-to-csv-export";

export default {
    components: {
    MultiSelect,
        "tabla-datos": TablaDatos,
    },
    data() {
        return {
        mievento:[],
        usuarioseleccionado:'',
        companiaseleccionada:'',
            mostrar:false,
            filtroExpediente: '',
            companias:[],
            usuarios:[],
            pageselec:1,
            numDatos:15,
            total: '',
            expedientes: [],
            parametros: '',
            columnas: [
                {
                    header:'Tipo',
                    field: 'class',

                },
                {
                    header: 'Expediente',
                    field: 'codigo_servicio',
                    sortable: false,
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'id_servicio',
                            nombreIddos: 'codigo_servicio',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id, codigo) => {
                                localStorage.setItem('nombreservicio' + id, codigo);
                                this.$router.push({
                                    name: 'Servicio',
                                    params: {
                                        id: id,
                                        nombreservicio: codigo,
                                    }
                                });
                            }
                        },
                    ]
                },
                {
                    header: 'Compañia',
                    field: 'nombre_compania',
                    sortable: false,
                },
                {
                    header: 'Fecha/Hora',
                    field: 'fecha_hora',
                    sortable: true,
                },
                {
                    header: 'Gremio',
                    field: 'gremio_servicio',
                    sortable: true,
                },
                {
                    header: 'Direción',
                    field: 'direccion_cliente',
                    sortable: false,
                },

                {
                    header: 'Contacto',
                    field: 'telefonos_cliente',
                    sortable: false,
                },
                {
                    header: 'Tramitador',
                    field: 'nombre_tramitador',
                    sortable: false,
                },
            ]
        }
    },
    methods: {        
        async cargarCompanias() {
            const api = new PwgsApi();
            const datos = await api.get('companias/simple?sortField=nombre&sortOrder=1');
            this.companias = datos.datos;
        },        
        async cargarUsuarios() {
            const api = new PwgsApi();
            const datos = await api.get('usuarios/gestion,simple');
            this.usuarios = datos.datos;
        },
        onPage(evnt){
            localStorage.setItem("pageselecasig", evnt.page);
            localStorage.setItem("numdatsasig", evnt.rows);
        },
        async montarcsv(event) {
            event.page = 1;
            event.first = 0;
            event.rows = 5000; 
            if (this.companiaseleccionada) {
            event.ids_companias = this.companiaseleccionada;
            }
            if (this.usuarioseleccionado) {
            event.ids_usuarios = this.usuarioseleccionado;
            }
            if(this.filtroExpediente !=''){
                event.buscador = this.filtroExpediente;
            }else{
                delete event.buscador;
            }
            const api = new PwgsApi;
            const aux = await api.post('avisos/asignaciones',event);
            let fechahoy = '_F' + new Date().toLocaleDateString().replaceAll('/', '-') + '_T' + new Date().toLocaleTimeString().replaceAll(':', '-');
            jsonToCsvExport({ data: aux.datos, filename: "Asignaciones_" + fechahoy, delimiter: ";" });
            
        },
        async obtenerExpedientes(event) { 
            if (this.companiaseleccionada) {
            event.ids_companias = this.companiaseleccionada;
            }
            if (this.usuarioseleccionado) {
            event.ids_usuarios = this.usuarioseleccionado;
            }
            if(this.filtroExpediente !=''){
                event.buscador = this.filtroExpediente;
            }else{
                delete event.buscador;
            }
            const api = new PwgsApi;
            const aux = await api.post('avisos/asignaciones',event);
            this.expedientes = aux.datos;
            this.total = aux.n_total_registros;
            this.$emit('evento_total_asignaciones', this.total); //Es llamado por ./Escritorio.vue
        },
    },

    activated() {
      this.obtenerExpedientes(this.mievento);  
    },

        mounted() {
        this.cargarCompanias();
        this.cargarUsuarios();
        this.pageselec = parseInt(localStorage.getItem('pageselecasig'));
        this.numdatos = parseInt(localStorage.getItem('numdatsasig'));
        this.mostrar = true;
        // this.obtenerExpedientes();
    },
    watch:{
    usuarioseleccionado(){
        this.pageselec = 1;
        this.mievento["first"]=0;
        if (!this.usuarioseleccionado) {
            delete this.mievento["ids_usuarios"];
        }
    },
    companiaseleccionada(){
        this.pageselec = 1;
        this.mievento["first"]=0;
        if (!this.companiaseleccionada) {
            delete this.mievento["ids_companias"];
        }
    },
    filtroExpediente(){
        this.pageselec = 1;
        this.mievento["first"]=0;
    }
    }
}
</script>
<style>
.p-dialog {
    width: 90%;
}
.p-datatable-header{

    visibility:hidden;
}

</style>